$(document).ready(function(){
    $('.s-header__burger').click(function(){
        $('.s-header').addClass('s-header--show');
        $('body').css('overflow','hidden');
    });
    $('.s-header__close').click(function(){
        $('.s-header').removeClass('s-header--show');
        $('body').css('overflow', 'auto');
    });
});